import { GetUserDetails } from './config'

const setUser = async () => {
  const userDetails = GetUserDetails()
  if (userDetails?._id) {
    try {
      if (process.env.NODE_ENV === 'production') {
        const Sentry = await import('@sentry/nextjs')
        Sentry.setUser({ id: userDetails?._id, email: userDetails?.email })
      }
    } catch (e) {
      // ignore Sentry errors in non-critical path
    }
  }
}

export const SentryService = {
  setUser,
}
